/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';
import { type ReactNode, useState } from 'react';

type Option = {
  label: string;
  value: string;
  leadingVisual?: ReactNode;
  description?: string;
  isDisabled?: boolean;
};

const Component = () => {
  const options: Option[] = [
    { label: 'Neo4j', value: 'neo4j' },
    { label: 'Aura', value: 'aura' },
    { label: 'Bloom', value: 'bloom' },
    { label: 'Data Importer', value: 'data-importer' },
    {
      label: 'GraphQL Library has a really really long label',
      value: 'graphql-library',
    },
    { label: 'Cypher', value: 'cypher' },
    { isDisabled: true, label: 'Unavailable', value: 'unavailable' },
    { label: 'Operations Manager', value: 'operations-manager' },
  ];
  const [value, setValue] = useState(options.slice(0, 5));

  return (
    <Combobox
      label="Products"
      isClearable
      isMulti
      options={options}
      value={value}
      onChange={(nextValue) => setValue(nextValue)}
    />
  );
};

export default Component;
